/* eslint-disable */

import { useSession } from 'next-auth/react'
import { useMutation } from '@apollo/client'
import { useState } from 'react'
import { getErrorMessage } from '@/util/getErrorMessage'
import { CreateOneDiscussionDocument } from '@/types/graphql/types'
import { useForm } from '@mantine/form'
import { showNotification } from '@mantine/notifications'
import useTranslation from 'next-translate/useTranslation'

const useDiscussion = ({
  comments,
  eventId,
}: {
  comments: any
  eventId: any
}) => {
  const [commentsData, setComments] = useState<any>(comments)
  const { t, lang } = useTranslation('common')
  const { data: sessionData } = useSession()
  const form = useForm({
    initialValues: {
      userId: sessionData?.user.id,
      eventId: eventId,
      comment: '',
      parentId: null,
    },
  })
  //create comment mutation
  const [create, { loading }] = useMutation(CreateOneDiscussionDocument, {
    onCompleted: newComment => {
      if (newComment.createOneDiscussion.Parent) {
        setComments(prevComments => {
          const index = prevComments.findIndex(
            comment => comment.id === newComment.createOneDiscussion.Parent.id,
          )

          if (index !== -1) {
            const updatedComments = [...prevComments]
            updatedComments[index] = newComment.createOneDiscussion.Parent
            return updatedComments
          }

          return prevComments
        })
      } else {
        setComments([...commentsData, newComment.createOneDiscussion])
      }

      form.setFieldValue('comment', '')
    },
    onError(error) {
      console.log(error)
      showNotification({
        title: t('error'),
        message: getErrorMessage(error),
        color: 'red',
        autoClose: false,
      })
    },
  })
  //submit comment data
  const handleSubmit = (values: typeof form.values) => {
    create({
      variables: {
        data: {
          comment: values.comment,
          ...(values.parentId
            ? {
                Parent: {
                  connect: {
                    id: values.parentId,
                  },
                },
              }
            : {}),
          User: {
            connect: {
              id: values.userId,
            },
          },
          Event: {
            connect: {
              id: values.eventId,
            },
          },
        },
      },
    })
  }
  return {
    handleSubmit,
    loading,
    create,
    commentsData,
    sessionData,
    form,
  }
}

export default useDiscussion
